export const isChild = (parent: HTMLElement, child: HTMLElement): boolean => {
    let node = child.parentNode;
    while (node !== null) {
      if (node === parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
}

export const isInterface = <T>(variable: any, interfaceObject: T): variable is T => {
  if (interfaceObject === null || typeof interfaceObject !== 'object') {
    return false;
  }

  if (typeof interfaceObject === 'object') {
    if (variable === null || typeof variable !== 'object') {
      return false;
    }

    const interfaceKeys = Object.keys(interfaceObject as object) as Array<keyof T>;
    return interfaceKeys.every((key) => {
      const interfaceValue = interfaceObject[key];
      const variableValue = variable[key];
      return isInterface(variableValue, interfaceValue);
    });
  } else if (typeof interfaceObject === 'function') {
    return variable instanceof interfaceObject;
  } else {
    return typeof variable === typeof interfaceObject;
  }
};